import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Cause for Applause", href: "#cause-for-applause" },
  { label: "About", href: "#about" },
  { label: "Speaking", href: "#speaking" },
  { label: "Results", href: "#results" },
  { label: "Books", href: "#books" },
  { label: "Magazine", href: "/magazine/", external: true },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#050505]/95 backdrop-blur-md border-b border-[#262626]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 font-display text-2xl tracking-tighter"
        >
          <span className="text-[#EC1985]">GZ</span>
          <span className="text-white">/</span>
          <span className="hidden sm:inline text-sm font-bold tracking-[0.2em] text-white">
            GARY&nbsp;ZELESKY
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-7 lg:gap-9">
          {links.map((l) => {
            const isPrimary = l.label === "Cause for Applause";
            const isMagazine = l.label === "Magazine";
            return (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/ /g, '-')}`}
                className={
                  isPrimary
                    ? "under-link text-[15px] font-extrabold uppercase tracking-[0.14em] text-[#EC1985] hover:text-white whitespace-nowrap"
                    : isMagazine
                    ? "under-link text-[15px] font-bold uppercase tracking-[0.14em] text-white/90 hover:text-white whitespace-nowrap inline-flex items-center gap-1.5"
                    : "under-link text-[15px] font-bold uppercase tracking-[0.14em] text-white/90 hover:text-white whitespace-nowrap"
                }
              >
                {isMagazine && <span className="h-1.5 w-1.5 rounded-full bg-[#EC1985] animate-pulse" aria-hidden="true" />}
                {l.label}
              </a>
            );
          })}
        </nav>

        <a
          href="#book"
          data-testid="nav-book-btn"
          className="hidden md:inline-flex btn-primary !py-2.5 !px-4 !text-[11px]"
        >
          Book Gary
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="md:hidden bg-[#0a0a0a] border-t border-[#262626] px-6 py-6 space-y-4"
        >
          {links.map((l) => {
            const isMagazine = l.label === "Magazine";
            return (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="flex items-center gap-2 text-base font-bold uppercase tracking-[0.15em] text-white/85"
              >
                {isMagazine && <span className="h-1.5 w-1.5 rounded-full bg-[#EC1985]" aria-hidden="true" />}
                {l.label}
              </a>
            );
          })}
          <a
            href="#book"
            onClick={() => setOpen(false)}
            className="btn-primary w-full"
          >
            Book Gary
          </a>
        </div>
      )}
    </header>
  );
}
